var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNameMerge } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';
import { buttonVariants } from '../common/buttonStyles';
var Link = React.forwardRef(function (_a, ref) {
    var _b = _a.asChild, asChild = _b === void 0 ? false : _b, className = _a.className, fullWidth = _a.fullWidth, href = _a.href, size = _a.size, variant = _a.variant, props = __rest(_a, ["asChild", "className", "fullWidth", "href", "size", "variant"]);
    var Comp = asChild ? Slot : 'a';
    return (_jsx(Comp, __assign({ className: classNameMerge("".concat(buttonVariants({ className: className, size: size, variant: variant }), " ").concat(fullWidth ? 'w-full' : 'w-fit')), href: href, ref: ref }, props)));
});
Link.displayName = 'Link';
export { buttonVariants as linkVariants, Link };
